import styled from 'styled-components';

export const ContactFormStyled = styled.div`
  max-height: 360px;
  border-radius: 12px;
  padding: 0.5rem;
`;
